import * as Sentry from '@sentry/react';

import { logger } from '@/lib/logger';

// Surfaces the real error React hides behind its generic "recoverable concurrent
// rendering" console message (issue #12523). Registered from main.tsx via the
// onRecoverableError option on createRoot.

interface RecoverableErrorInfo {
  componentStack?: string;
}

export function handleRecoverableError(
  error: unknown,
  errorInfo: RecoverableErrorInfo
): void {
  const err = error instanceof Error ? error : new Error(String(error));
  const componentStack = errorInfo?.componentStack;

  try {
    logger.error('React recovered from a concurrent-render error', err, {
      component: 'react-root',
      componentStack,
    });
    Sentry.captureException(err, {
      tags: { component: 'react-root', action: 'onRecoverableError' },
      extra: { componentStack },
    });
  } catch {
    /* capture must never break React's recovery path */
  }
}
